// extracted by mini-css-extract-plugin
module.exports = {"tags":"EmailsField_tags__2u3-Z","item":"EmailsField_item__qZm0n","sending":"EmailsField_sending__2O-d5"};